import { FormattedMessage } from 'react-intl';

export const Retailers = (
  <FormattedMessage
    defaultMessage='Retailers'
    id='btq.searchOverlay.retailer'
  />
);

export const SuggestedSearch = (
  <FormattedMessage
    defaultMessage='Suggested Search'
    id='plp.searchOverlay.suggestedSearch'
  />
);
